import React, { Component } from 'react';

export default class ItemInfo extends Component {
  render() {
    return (
      <div className="ItemInfo">
        <span className="ItemTitle">
          <img
            alt="SRO Filter"
            src="http://www.sawsro.com/media/images/equipment/com_itemsign.PNG"
            className="imageclear"
          />
          Giant Barbaric Sword (+250)
        </span>
        <br />
        <br /> <span className="ItemTitle">Seal of Sun</span>
        <br />
        <span className="ItemSubTitle">
          Sort of item: Blade
          <br />
          Degree: 10 degrees
        </span>
        <br /> <br />
        Phy. atk. pwr. 15487 ~ 15743 (+0%)
        <br />
        Mag. atk. pwr. 23101 ~ 23428 (+0%)
        <br />
        Durability 140/140 (+0%)
        <br />
        Attack distance 0.6 m<br />
        Attack rate 119 (+0%)
        <br />
        Critical 8 (+22%)
        <br />
        Phy. reinforce 257.1 ~ 295.5 (+0%)
        <br />
        Mag. reinforce 386.7 ~ 435.9 (+0%) <br />
        <br />
        Required level 90
        <br />
        Chinese
        <br />
        <span className="ItemSubTitle">Max. no. of magic options: 9 Unit</span>
        <br />
        <br />
        <span className="ItemBlue">Str 5 Increase</span>
        <br />
        <span className="ItemBlue">Int 6 Increase</span> <br />
        <b>Able to use Advanced elixir</b>
      </div>
    );
  }
}
